import { render, staticRenderFns } from "./CallToActionB.vue?vue&type=template&id=2e758e30&"
import script from "./CallToActionB.vue?vue&type=script&lang=js&"
export * from "./CallToActionB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports